const RANKING = [
  { rank: 1, title: '咒术回战', tag: '日漫', change: 'up', hot: '9.8' },
  { rank: 2, title: '我独自升级', tag: '韩漫', change: 'up', hot: '9.7' },
  { rank: 3, title: '一人之下', tag: '国漫', change: 'same', hot: '9.6' },
  { rank: 4, title: '间谍过家家', tag: '日漫', change: 'up', hot: '9.5' },
  { rank: 5, title: '镖人', tag: '国漫', change: 'down', hot: '9.4' },
  { rank: 6, title: '葬送的芙莉莲', tag: '日漫', change: 'up', hot: '9.3' },
  { rank: 7, title: '全知读者视角', tag: '韩漫', change: 'new', hot: '9.2' },
];

const changeIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  down: 'ri-arrow-down-line text-foreground-400',
  same: 'ri-subtract-line text-foreground-400',
  new: 'text-accent-500',
};

const changeLabel: Record<string, string> = {
  up: '',
  down: '',
  same: '',
  new: 'NEW',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
            排行榜
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            本周热门漫画人气排名
          </p>
        </div>

        <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
          {RANKING.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-3 px-4 md:px-6 py-4 cursor-pointer hover:bg-background-50 transition-colors ${
                idx < RANKING.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-lg font-bold text-sm ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-300 text-accent-900'
                  : item.rank === 3
                  ? 'bg-accent-200 text-accent-800'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-950">{item.title}</h3>
                  <span className="px-1.5 py-0.5 text-[10px] font-medium rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-1 shrink-0">
                <span className="text-xs font-medium text-foreground-600">{item.hot}</span>
                {item.change === 'new' ? (
                  <span className="text-[10px] font-bold text-accent-500">NEW</span>
                ) : (
                  <i className={`${changeIcon[item.change]} text-xs`}></i>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}